import { ACCESS_LEVEL_ENTITY } from "./accessLevelEntity";
export default {
    [ACCESS_LEVEL_ENTITY.WORKSPACE]: "Пространство",
    [ACCESS_LEVEL_ENTITY.PROJECT]: "Проект"
};
